<template>
	<div class="container" v-if="loading">
		<div class="spinner"></div>
		<div>Loading..</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	computed: {
		loading () {
			return this.$store.state.config.httpInProgress;
		}
	}
})
</script>

<style scoped>
	@import '@/styles/animations.scss';
	.container{
		text-align: center;
		position: fixed;
		top: calc(50vh - 100px);
		left: calc(50vw - 50px);
		padding-top: 10px;
		width: 100px;
		height: 100px;
		background: rgba(249, 248, 248, 0.9);
		border-radius: 10px;
		border: 1px solid #f3f3f3;
		animation: fadeIn 0.3s linear;
		z-index: 9999
	}

	.spinner {
		display: inline-block;
		border: 6px solid #e6e5e5;
		border-top: 6px solid var(--bulma-primary);
		border-radius: 50%;
		width: 50px;
		height: 50px;
		animation: spin 2s linear infinite;
	}
</style>
